import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/dataflow/services/kill";

export class GetDataFlowKillServiceCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    params: GetDataFlowKillServiceReqData = null;

    constructor(serviceName: string) {
        super();
        this.params = new GetDataFlowKillServiceReqData(serviceName);
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(null, null, this.params);
        return new ApiGenericResponse(res);
    }
}

export class GetDataFlowKillServiceReqData {
    serviceName: string;

    constructor(serviceName: string) {
        this.serviceName = serviceName;
    }
}
